(() => {
  if (window.__wiReturnShoppingReady) return;
  window.__wiReturnShoppingReady = true;

  const browseKey = 'worthit.shopping-return.v1';
  const restoreKey = 'worthit.shopping-restore.v1';
  const maxAge = 30 * 60 * 1000;
  const maxScroll = 10000000;
  const reviewRatings = ['all', 'critical', 'positive', 'star-1', 'star-2', 'star-3', 'star-4', 'star-5'];
  const reviewSorts = ['newest', 'lowest', 'highest'];
  const maxReviewVisible = 1200;
  let pendingReview = null;

  const pathAllowed = (path) => path === '/' || /^\/(?:products\/[a-z0-9]+(?:-[a-z0-9]+)*|collections(?:\/[a-z0-9]+(?:-[a-z0-9]+)*)?)\/?$/.test(path);

  function currentRoute() {
    try {
      const url = new URL(window.location.href);
      if (url.origin !== window.location.origin || url.username || url.password || !pathAllowed(url.pathname)) return null;
      const path = url.pathname === '/' ? '/' : url.pathname.replace(/\/$/, '');
      const variants = url.searchParams.getAll('variant');
      const variant = path.startsWith('/products/') && variants.length === 1 && /^[1-9][0-9]{0,19}$/.test(variants[0]) ? variants[0] : null;
      return path + (variant ? '?variant=' + variant : '');
    } catch (_) {
      return null;
    }
  }

  function savedRoute(value) {
    if (typeof value !== 'string' || value.length > 220 || !value.startsWith('/') || value.startsWith('//') || /[%\\#\s]/.test(value)) return null;
    const parts = value.split('?');
    if (parts.length > 2 || !pathAllowed(parts[0]) || (parts[0] !== '/' && parts[0].endsWith('/'))) return null;
    if (parts.length === 2 && (!parts[0].startsWith('/products/') || !/^variant=[1-9][0-9]{0,19}$/.test(parts[1]))) return null;
    return value;
  }

  function validReviewUi(state) {
    if (!state || Array.isArray(state) || typeof state !== 'object' || Object.keys(state).sort().join(',') !== 'photos,productId,rating,sort,visible') return null;
    if (typeof state.productId !== 'string' || !/^[1-9][0-9]{0,19}$/.test(state.productId) || !reviewRatings.includes(state.rating) || !reviewSorts.includes(state.sort) || typeof state.photos !== 'boolean') return null;
    if (!Number.isSafeInteger(state.visible) || state.visible < 0 || state.visible > maxReviewVisible) return null;
    return { productId: state.productId, rating: state.rating, photos: state.photos, sort: state.sort, visible: state.visible };
  }

  function reviewSection(productId) {
    const route = currentRoute();
    if (!route || !route.startsWith('/products/')) return null;
    const sections = Array.from(document.querySelectorAll('[data-wi-reviews]')).filter(section => {
      const id = /^WorthItReviews-([1-9][0-9]{0,19})$/.exec(section.id)?.[1];
      const product = section.closest('product-info[id^="MainProduct-"]');
      return section.isConnected && id && (!productId || id === productId) && product?.dataset.productId === id && product.dataset.url === route.split('?')[0];
    });
    return sections.length === 1 ? sections[0] : null;
  }

  function captureReviewUi() {
    const section = reviewSection();
    if (!section || section.dataset.wiReviewsReady !== 'true') return null;
    const grid = section.querySelector('[data-wi-review-grid]');
    const rating = section.querySelector('[data-wi-review-filter]');
    const sort = section.querySelector('[data-wi-review-sort]');
    const photos = section.querySelector('[data-wi-review-photo-filter]');
    if ([grid, rating, sort, photos].some(node => !node || node.closest('[data-wi-reviews]') !== section)) return null;
    const pressed = photos.getAttribute('aria-pressed');
    if (pressed !== 'true' && pressed !== 'false') return null;
    const visible = Array.from(grid.querySelectorAll('[data-wi-review]')).filter(card => card.closest('[data-wi-review-grid]') === grid && card.closest('[data-wi-reviews]') === section && !card.hidden).length;
    return validReviewUi({ productId: section.id.slice('WorthItReviews-'.length), rating: rating.value, photos: pressed === 'true', sort: sort.value, visible });
  }

  function applyPendingReview() {
    if (!pendingReview || currentRoute() !== pendingReview.route) return;
    const section = reviewSection(pendingReview.state.productId);
    if (!section || section.dataset.wiReviewsReady !== 'true') return;
    const detail = { state: { ...pendingReview.state }, accepted: false };
    section.dispatchEvent(new CustomEvent('wi:reviews:restore-ui', { detail }));
    if (detail.accepted === true) pendingReview = null;
  }

  function validRecord(record) {
    if (!record || Array.isArray(record) || typeof record !== 'object') return null;
    const keys = Object.keys(record).sort().join(',');
    const now = Date.now();
    const legacy = keys === 'at,route,version,y' && record.version === 1;
    const withUi = keys === 'at,reviewUi,route,version,y' && record.version === 2;
    if ((!legacy && !withUi) || !savedRoute(record.route)) return null;
    if (!Number.isSafeInteger(record.at) || record.at > now || now - record.at > maxAge) return null;
    if (!Number.isSafeInteger(record.y) || record.y < 0 || record.y > maxScroll) return null;
    const core = { version: 1, route: record.route, y: record.y, at: record.at };
    const reviewUi = withUi && record.route.startsWith('/products/') ? validReviewUi(record.reviewUi) : null;
    return reviewUi ? { ...core, version: 2, reviewUi } : core;
  }

  function remove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (_) {}
  }

  function read(key, consume = false) {
    try {
      const raw = window.sessionStorage.getItem(key);
      if (consume) window.sessionStorage.removeItem(key);
      if (!raw || raw.length > 640) {
        if (raw) remove(key);
        return null;
      }
      const record = validRecord(JSON.parse(raw));
      if (!record) remove(key);
      return record;
    } catch (_) {
      remove(key);
      return null;
    }
  }

  function write(key, record) {
    try {
      const raw = JSON.stringify(record);
      window.sessionStorage.setItem(key, raw);
      return window.sessionStorage.getItem(key) === raw;
    } catch (_) {
      return false;
    }
  }

  function captureBrowse() {
    const route = currentRoute();
    if (!route || !Number.isFinite(window.scrollY)) return;
    const record = { version: 1, route, y: Math.min(maxScroll, Math.max(0, Math.round(window.scrollY))), at: Date.now() };
    const reviewUi = captureReviewUi();
    if (reviewUi) { record.version = 2; record.reviewUi = reviewUi; }
    if (!write(browseKey, record)) remove(browseKey);
  }

  function restorePending() {
    const record = read(restoreKey, true);
    if (!record || currentRoute() !== record.route) return;
    const reviewPending = record.reviewUi ? { route: record.route, state: record.reviewUi } : null;
    pendingReview = reviewPending;
    applyPendingReview();
    let ended = false;
    let firstFrame;
    let secondFrame;
    let waitTimer;
    const cancelEvents = ['pointerdown', 'touchstart', 'wheel', 'keydown'];
    const finish = () => {
      ended = true;
      if (pendingReview === reviewPending) pendingReview = null;
      clearTimeout(waitTimer);
      cancelAnimationFrame(firstFrame);
      cancelAnimationFrame(secondFrame);
      window.removeEventListener('load', schedule);
      window.removeEventListener('pagehide', finish);
      cancelEvents.forEach((name) => window.removeEventListener(name, finish, true));
    };
    const schedule = () => {
      if (ended) return;
      clearTimeout(waitTimer);
      applyPendingReview();
      firstFrame = requestAnimationFrame(() => {
        if (!ended) applyPendingReview();
        secondFrame = requestAnimationFrame(() => {
          if (!ended && currentRoute() === record.route) window.scrollTo({ top: record.y, left: 0, behavior: 'instant' });
          finish();
        });
      });
    };
    cancelEvents.forEach((name) => window.addEventListener(name, finish, { capture: true, passive: true, once: true }));
    window.addEventListener('pagehide', finish, { once: true });
    if (document.readyState === 'complete') schedule();
    else {
      window.addEventListener('load', schedule, { once: true });
      waitTimer = setTimeout(schedule, 2000);
    }
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[data-wi-return-shopping]') : null;
    if (!link || !link.isConnected || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const drawer = link.closest('cart-drawer');
    if (drawer && currentRoute() && drawer.classList.contains('active') && typeof drawer.close === 'function') {
      const y = Math.max(0, Math.min(maxScroll, window.scrollY));
      try {
        drawer.close();
        if (drawer.classList.contains('active')) return;
        event.preventDefault();
        requestAnimationFrame(() => window.scrollTo({ top: y, left: 0, behavior: 'instant' }));
      } catch (_) {}
      return;
    }
    if (!/^\/cart\/?$/.test(window.location.pathname)) return;
    const record = read(browseKey);
    if (!record) return;
    if (!write(restoreKey, record)) { remove(restoreKey); return; }
    try {
      window.location.assign(record.route);
      event.preventDefault();
    } catch (_) {
      remove(restoreKey);
    }
  });

  document.addEventListener('wi:reviews:ready', event => {
    if (pendingReview && event.target === reviewSection(pendingReview.state.productId)) applyPendingReview();
  });
  window.addEventListener('pagehide', captureBrowse);
  window.addEventListener('pageshow', restorePending);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restorePending, { once: true });
  else restorePending();
})();
